import { ShipInfo } from '@ais-ui/websockets';
import React from 'react';
import { BaseInformation } from './ShipDetailsTabs/BaseInformation';
import { IntegrityInformation } from './ShipDetailsTabs/IntegrityInformation';
import { RegisterInformation } from './ShipDetailsTabs/RegisterInformation';
import { AdvancedVesselInformation } from './ShipDetailsTabs/AdvancedVesselInformation';
import { TargetTab } from './TargetDetails';
import { NextPortPanel } from './ShipDetailsTabs/NextPortPanel';

interface ShipComponentProps {
  shipInfo: ShipInfo;
  tab: TargetTab;
}

export const ShipDetailsPanel = ({ shipInfo, tab }: ShipComponentProps) => {
  if (tab === 'base') {
    return <BaseInformation shipInfo={shipInfo}></BaseInformation>;
  } else if (tab === 'integrity') {
    return <IntegrityInformation shipInfo={shipInfo}></IntegrityInformation>;
  } else if (tab === 'register') {
    return <RegisterInformation shipInfo={shipInfo}></RegisterInformation>;
  } else if (tab === 'advancedVessel') {
    return (
      <AdvancedVesselInformation
        shipInfo={shipInfo}
      ></AdvancedVesselInformation>
    );
  } else if (tab === 'nextPort') {
    return <NextPortPanel shipInfo={shipInfo}></NextPortPanel>;
  }
};
